























import {Mutation} from 'vuex-module-decorators';
import {Component, Emit, Vue, Watch} from 'vue-property-decorator';
import userModule from '@/model/store/modules/user-module';
import appModule from '@/model/store/modules/app-module';
import detailModule from '@/model/store/modules/detail-module';
import contentsService from '@/model/services/contents-service';
import {GCICategoryInfoRes, GCIContentsListRes, GCICategoryListRes, GCIContentsInfoRes} from '@/model/dto/res/contents/get-category-list-res';
import _ from 'lodash';

@Component({
  components: {
  }
})
export default class CategoryChips extends Vue {
  /** Data **/
  /** Computed **/
  get categoryInfo() {
    return appModule.categoryInfo;
  }

  get contents() {
    return detailModule.contents;
  }

  get breadCrumbs() {
    return detailModule.breadcrumbs;
  }

  /** Methods **/
  private onRouter(type: string) {
    const token = this.$route.query.token ?? userModule.apiToken;
    this.$router.push({path: `/${type}` }).catch(err => err);
  }

  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    console.log(err);
    return err;
  }

}
